import { NavigateFunction } from "react-router-dom";
import { authFetch, refreshAccessToken, getAccessToken } from "./auth";

// Thin compatibility shims over the central auth module. Token storage and the
// refresh/retry logic now live in ./auth (in-memory access token + HttpOnly
// refresh cookie). These wrappers preserve the old call signatures.

export const fetchWithAuthRetry = async (
  input: RequestInfo,
  init: RequestInit,
  navigate: NavigateFunction,
): Promise<Response> => {
  const res = await fetch(input, {
    ...init,
    credentials: "include",
    headers: {
      ...init.headers,
      Authorization: `Bearer ${getAccessToken() || ""}`,
      "X-Auth-Mode": "cookie",
    },
  });

  if (res.status !== 401) return res;

  const token = await refreshAccessToken();
  if (!token) {
    navigate("/login");
    throw new Error("Refresh failed, redirecting to login");
  }

  return fetch(input, {
    ...init,
    credentials: "include",
    headers: {
      ...init.headers,
      Authorization: `Bearer ${token}`,
      "X-Auth-Mode": "cookie",
    },
  });
};

// Default export without navigate for simpler API usage.
const fetchWithAuthRetryDefault = async (
  input: RequestInfo,
  init?: RequestInit,
): Promise<Response> => authFetch(input, init);

export default fetchWithAuthRetryDefault;
